import { createContext} from 'react';

const trypiContext = createContext();

export default trypiContext;